export function anyTrue(map) {
  if (!map || typeof map !== "object") return false;
  return Object.values(map).some((v) => v === true);
}

export function isCreatorRole(role = "") {
  const normalized = String(role).toLocaleLowerCase("tr-TR");
  return ["oluşturucu", "olusturucu", "creator"].includes(normalized);
}

export function canManagePermissions(role = "", userPermissions = {}) {
  return isCreatorRole(role) || userPermissions?.yetkiKontrol === true || userPermissions?.YetkiKontrol === true;
}

export function buildVisibleProjects({ role, userPermissions = {}, fallbacks = {} }) {
  const faturaGorunur =
    userPermissions?.takip === true || userPermissions?.yonetici === true;

  const aracTakipPerm =
    userPermissions?.["arac-takip"] ??
    userPermissions?.aractakip ??
    fallbacks.aracTakipMap ??
    {};
  const aracTakipGorunur = isCreatorRole(role) || anyTrue(aracTakipPerm);

  const kazaTakipGorunur = userPermissions?.kazatakip?.giris === true;
  const personelTakipGorunur = anyTrue(userPermissions?.personeltakip ?? fallbacks.personelMap);

  const mazotFromContext = userPermissions?.["mazot-takip"];
  const mazotFromFallback = fallbacks.mazotMap;
  const mazotTakipGorunur =
    mazotFromContext?.giren === true ||
    mazotFromFallback?.giren === true ||
    userPermissions?.mazottakip?.giren === true ||
    userPermissions?.yonetici === true;

  const kisiMap = userPermissions?.["kisiye-ozel-rapor"] ?? fallbacks.kisiRaporMap ?? {};
  const ozelRaporlarGorunur = anyTrue(kisiMap);

  const hazirBetonPerm = userPermissions?.["hazir-beton"] ?? fallbacks.hazirBetonMap ?? {};
  const hazirBetonGorunur = anyTrue(hazirBetonPerm);

  const filoTakipPerm = userPermissions?.filotakip ?? fallbacks.filoTakipMap ?? {};
  const filoTakipGorunur = anyTrue(filoTakipPerm);

  const kontrolFormlariPerm =
    userPermissions?.["kontrol-formlari"] ?? fallbacks.kontrolFormlariMap ?? {};
  const kontrolFormlariGorunur = anyTrue(kontrolFormlariPerm);

  return [
    { name: "Araç Takip Sistemi", path: "/arac-takip", visible: aracTakipGorunur },
    { name: "Fatura Takip Sistemi", path: "/fatura-takip", visible: faturaGorunur },
    { name: "Kaza Takip Sistemi", path: "/kaza-takip", visible: kazaTakipGorunur },
    { name: "Personel Takip Sistemi", path: "/personel-takip", visible: personelTakipGorunur },
    { name: "Kontrol Formları", path: "/kontrol-formlari", visible: kontrolFormlariGorunur },
    { name: "Filo Takip Sistemi", path: "/filo-takip", visible: filoTakipGorunur },
    { name: "Mazot & Tank Takip", path: "/mazot-takip", visible: mazotTakipGorunur },
    { name: "Hazır Beton Operasyonları", path: "/hazir-beton", visible: hazirBetonGorunur },
    { name: "Özel Raporlar", path: "/kisiye-ozel-rapor", visible: ozelRaporlarGorunur },
    { name: "Yetki Yönetimi", path: "/yetki-yonetimi", visible: canManagePermissions(role, userPermissions) },
  ].filter((project) => project.visible);
}
